/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IContentBlockViewProps } from '@msdyn365-commerce-modules/content-block/src/modules/content-block/./content-block';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const ContentBlockView: React.FC<IContentBlockViewProps> = props => {
    const { contentBlockContainer, imageContainer, detailsContainer, title, text, links, image } = props;
    // @ts-ignore
    const contentBlockImage = image && <img src={image.props.src} alt={image.props.altText} title={image.props.title} />;
    const entireLink = contentBlockContainer.className.includes('linkplacement__entirebanner');
    // @ts-ignore
    const link = links && 'props' in links ? links.props.links[0].linkUrl.destinationUrl : '';
    return (
        <Module {...contentBlockContainer}>
            {entireLink ? (
                <a href={link}>
                    <Node {...imageContainer}>{contentBlockImage}</Node>
                    <Node {...detailsContainer}>
                        {title}
                        {text}
                    </Node>
                </a>
            ) : (
                <>
                    {image && <Node {...imageContainer}>{contentBlockImage}</Node>}
                    <Node {...detailsContainer}>
                        {title}
                        {text}
                        {links}
                    </Node>
                </>
            )}
        </Module>
    );
};

export default ContentBlockView;
